/// <reference path='../../../../../common/types/window-config.d.ts' />
import * as React from 'react';
import { useEffect, useState } from 'react';
import { AuthService } from '@enginuity-common/services/authService';
import { ChangeComplete } from '../../components/misc/change-complete';
import { Button } from '@enginuity-apps-ui-components/atoms/button/button';
import GenericErrorMessage from '../../components/misc/generic-error-message';


export type ISignoutProps = {
  fromUri: string;
};

export default function Signout({fromUri}: ISignoutProps) {
  const authService = new AuthService({
    baseUrl: window.spConfig.authBaseUrl,
    clientId: window.spConfig.authClientId
  });

  const [signedOut, setSignedOut] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    authService.signOut()
      .then(() => setSignedOut(true))
      .catch(err => setError(err.message));
  }, []);

  return <div>
    {error ? (
      <>
        <GenericErrorMessage errorMsg={error || "An error occured"} fromUri={fromUri}></GenericErrorMessage>
      </>
    ) :
      signedOut ? <ChangeComplete>
        <div className="row spacer-32">
          <div className="col-12">
            <h3>You have been successfully signed out.</h3>
          </div>
        </div>
        <div className="row spacer-48">
          <div className="col-12">
            <Button buttonType="link" href="/signin" className="cmp-button--secondary">Sign in</Button>
          </div>
        </div>
      </ChangeComplete>
        : <ChangeComplete>
          <div className="row spacer-32">
            <div className="col-12">
              <h3>Signing out…</h3>
            </div>
          </div>
        </ChangeComplete>
    }
  </div>;
}
